import { render } from "./SampleOriginClassFilter.vue?vue&type=template&id=6839eb0e"
import script from "./SampleOriginClassFilter.vue?vue&type=script&lang=js"
export * from "./SampleOriginClassFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__